import { tv } from 'tailwind-variants';

export const bodyContainer = tv({
  slots: {
    base: 'w-full  overflow-y-hidden',
    footer: 'w-full',
    container: 'w-full h-full flex-1 overflow-y-auto flex flex-row',
  },
  variants: {
    isExport: {
      true: {},
      false: {},
    },
    sidebarOpen: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      isExport: true,
      sidebarOpen: true,
      className: {
     
      },
    },
    {
      isExport: true,
      sidebarOpen: false,
      className: {
     
      },
    },
    {
      isExport: false,
      sidebarOpen: true,
      className: {
   
      },
    },
    {
      isExport: false,
      sidebarOpen: false,
      className: {
       
      },
    },
  ]
});